import { render } from "./NotiTemp.vue?vue&type=template&id=57c61090&scoped=true"
import script from "./NotiTemp.vue?vue&type=script&lang=js"
export * from "./NotiTemp.vue?vue&type=script&lang=js"

import "./NotiTemp.vue?vue&type=style&index=0&id=57c61090&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c61090"]])

export default __exports__